<table mat-table [dataSource]="reportRows()" data-qa="import-status-table">
    <ng-container matColumnDef="step">
        <th mat-header-cell *matHeaderCellDef>Prüfung</th>
        <td mat-cell *matCellDef="let element" [class.disabled]="element.isDisabled" [class.valid]="element.isValid" [class.invalid]="!element.isValid">
            @if (element.rowType === 'default') {
                <mat-icon>{{element.stepIcon}}</mat-icon>{{element.stepName}}
            } @else {
               {{element.stepName}}
            }
        </td>
    </ng-container>

    <ng-container matColumnDef="limit">
        <th mat-header-cell *matHeaderCellDef>Grenzwert</th>
        <td mat-cell *matCellDef="let element">
            @if (element.rowType === 'default') {
                @if (element.limitType === 'bruttoleistung-by-stadtwerke')  {
                    {{element.limit | leistungseinheit:Leistungseinheit.MW }}
                } @else {
                    {{element.limit}}
                }
            }
        </td>
    </ng-container>

    <ng-container matColumnDef="count">
        <th mat-header-cell *matHeaderCellDef>Letzter Import</th>
        <td mat-cell data-qa="count-column" *matCellDef="let element"
            [class.feedback-primary-accent]="element.isValid && element.rowType === 'default'"
            [class.feedback-warn-accent]="!element.isValid"
        >
            @if (element.rowType === 'default') {
                @if (element.limitType === 'bruttoleistung-by-stadtwerke') {
                    {{element.count | leistungseinheit:Leistungseinheit.MW }}
                } @else {
                    {{element.count}}
                }
                @if (element.isValid) {
                    <mat-icon class="feedback-primary" svgIcon="innogy_picto_check"></mat-icon>
                } @else {
                    <mat-icon class="icon-warn">error</mat-icon>
                }
            }
            @if (element.rowType === 'exceededBruttoleistung') {
               {{element.count | leistungseinheit:Leistungseinheit.MW }}
            }
            @if (element.rowType === 'ungueltigeAnlage') {
                {{element.count}}
            }
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
